import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from './isFeatureEnabled';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export default function isImmutableidEnabledForMailbox(
    mailboxInfo?: MailboxInfo,
    dontThrowErrorIfNotInitialized?: boolean
): boolean {
    return isAccountFeatureEnabled(
        'fwk-immutable-ids',
        mailboxInfo ?? getGlobalSettingsAccountMailboxInfo(),
        dontThrowErrorIfNotInitialized
    );
}
